import { ShieldCheck, Star, Sprout, Crown } from "lucide-react";

export const BADGE_META = {
  "Community Admin": { color: "#7c3aed", icon: Crown },
  "Guardian": { color: "#F97316", icon: ShieldCheck },
  "Verified Resident": { color: "#16A34A", icon: Star },
  "New Member": { color: "#6b7280", icon: Sprout },
};

export const TrustBadge = ({ badge, size = "md", testId }) => {
  const meta = BADGE_META[badge] || BADGE_META["New Member"];
  const Icon = meta.icon;
  const s = size === "sm" ? "text-[10px] px-2 py-0.5 gap-1" : "text-xs px-2.5 py-1 gap-1.5";
  const ic = size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5";
  return (
    <span data-testid={testId} className={`inline-flex items-center font-bold rounded-full ${s}`} style={{ background: `${meta.color}1a`, color: meta.color }}>
      <Icon className={ic} /> {badge}
    </span>
  );
};

export const STATUS_META = {
  active: { color: "#16A34A", label: "Active" },
  restricted: { color: "#F59E0B", label: "Restricted" },
  suspended: { color: "#DC2626", label: "Suspended" },
};
